/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import data from './data';
export default {
  mixins: [data],
  methods: {
    build_query_fields: function build_query_fields(fields) {
      var queryFields = [];
      var line = [];
      var hiddenQueryFields = [];
      var queryLineNums = this.comModelProps.queryLineNums;
      var searchShow = false;
      var req = Object.assign({}, this.$route.query, this.params);
      var temValue = { user: this.$store.getters.sessionUser, req: req };
      for (var n = 0, len = fields.length; n < len; n++) {
        var item = fields[n];
        if (item.defaultValue && item.defaultValue.trim() !== '') {
          if (item.isDisplay === '1') {
            var tem = this.template(item.defaultValue.trim(), temValue);
            item.searchValue = tem;
            item.defaultValue = tem;
          }
        } else {
          item.defaultValue = null;
        }
        if (item.startDefault) {
          item.start = this.template(item.startDefault.trim(), temValue);
        }
        if (item.endDefault) {
          item.end = this.template(item.endDefault.trim(), temValue);
        }

        var searchId = 'query:' + item.name.toLowerCase();
        item.queryId = searchId;
        if (item.isDisplay === '1') {
          if (item.controlTypeName && item.dicType === '3') {
            var option = [];
            if (item.dicInfo) {
              var dicObj = JSON.parse(item.dicInfo);
              for (var k in dicObj) {
                option.push({ 'key': k, 'text': dicObj[k] });
              }
            }
            item.option = option;
          }
          searchShow = true;
          line.push(item);
        } else {
          hiddenQueryFields.push(item);
        }

        if (this.searchType === '01') {
          if (line.length === parseInt(queryLineNums) || n + 1 === len) {
            queryFields.push(line);
            line = [];
          }
        }
      }
      this.searchShow = searchShow;
      if (this.searchType === '02' || this.searchType === '03') {
        queryFields.push(line);
      }
      this.queryFields = JSON.parse(JSON.stringify(queryFields));
      this.hiddenQueryFields = hiddenQueryFields;
    },
    reset_query_condis: function reset_query_condis() {
      /* var _that = this
      this.queryFields.forEach(function (fields) {
        fields.forEach(function (item) {
          _that.$set(item, 'searchValue', item.defaultValue)
          _that.$set(item, 'start', item.startDefault)
          _that.$set(item, 'end', item.endDefault)
        })
      })
      this.query_grid_data(1) */
      var params = this.getGridRequestParams();
      this.$emit('resetGird', params);
      if (this.funcMark !== '') {
        this.init_func_config(this.dataGridId);
      } else if (this.gridMark !== '') {
        this.showOper = false;
        this.init_grid_config(this.dataGridId);
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/data-grid/mixins/queryField.js
// module id = 36
// module chunks = 0